export default function toCamelCaseStringUtil (str) {
  // Check if the string is already camel case
  if (/^[a-z]+([A-Z][a-z]*)*$/.test(str)) {
    return str
  }

  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase())
}
